export const PAYMENTS_LIST = [
  {
    label: 'Счет-фактура',
    value: 'invoice',
  },
  {
    label: 'Wayforpay',
    value: 'wayforpay',
  },
  {
    label: 'Приват24',
    value: 'privat24',
  },
  {
    label: 'Liqpay',
    value: 'liqpay',
  },
  {
    label: 'Stripe',
    value: 'stripe',
  },
]


// WEBPACK FOOTER //
// ./resources/assets/js/components/PaymentMethodEdit/const.js